export const teamPlayerRoles = {
  CEO: 'CEO',
  PD: 'Product',
  PM: 'Marketing',
  OP: 'Operations',
  FI: 'Finance'
}

export const teamPlayerRowsPerPage = {
  15: 15,
  25: 25,
  50: 50
};


// WEBPACK FOOTER //
// ./src/instructor/constants.js